<template>
  <div class="index-page">
    <img src="../assets/images/1.png" alt="" style="display: none" />
    <div class="page-info">
      <!-- <van-notice-bar
          left-icon="volume-o"
          color="#ed6a0c"
          text="温馨提示：本公司不刷单、不返佣，请勿轻信他人，谨防上当受骗!!!!"
        /> -->
      <div class="title-row">
        <div class="img-logo">
          <img src="../assets/images/ks_icon.png" alt="" />
          <span>快币充值</span>
        </div>

        <div class="right-icon">
          <span
            style="
              font-size: 12px;
              display: flex;
              align-items: center;
              color: #000;
            "
            @click="chat"
          >
            <van-icon name="phone-o" size="16" /> 拨打客服电话
          </span>
        </div>
      </div>
    </div>
    <div class="page-main">
      <div class="header">
        <div class="logined" v-if="isLogin">
          <div class="userImg">
            <img :src="userInfo.headImg" alt="" />
          </div>
          <div class="userInfo">
            <p style="margin-bottom: 5px; font-size: 18px">
              {{ userInfo.nickName }}
            </p>
            <p style="color: #777">ID:{{ userInfo.userId }}</p>
          </div>
          <div class="header-bar">
            <van-button color="#fe2c55" size="normal" @click="loginCheckOut"
              >切换账号</van-button
            >
          </div>
        </div>

        <div class="unlogin" v-else>
          <div class="input-group">
            <div class="input-div">
              <input
                type="text"
                v-model.trim="accountNumber"
                @blur="onBlur"
                @focus="onfocus"
                placeholder="请输入快手号"
              />
            </div>
            <div class="header-bar">
              <van-button
                color="#fe2c55"
                type="primary"
                :disabled="accountNumber === ''"
                @click="affirmAcNumber"
                :loading="isLoading" 
                  loading-text="加载中"
                >确认账号</van-button
              >
            </div>
          </div>
          <div></div>
          <div class="account-help">
            <span @click="show = true">如何查看快手号？</span>
          </div>
        </div>
      </div>
      <div class="content">
        <ul class="item-list" v-if="list[currIdx]">
          <li v-for="(item, index) in list" :key="item.money">
            <div
              class="item"
              :class="{ 'item-active': currIdx === index }"
              @click="handerList(item, index)"
            >
              <span class="hot" v-if="item.type">
                <em v-if="item.type === 1">{{ item.tips }}</em>
                <em class="through" v-else-if="item.type === 2"
                  >￥{{ item.tips }}</em
                >
                <van-icon name="fire" color="#ffca00" />
              </span>
              <p class="doubi">
                <img src="../assets/images/ks_icon.png" alt="" />{{
                  item.doubi
                }}快币
              </p>
              <p class="rmb">￥{{ item.money }}</p>
            </div>
          </li>
        </ul>
        <div class="protocol-container">
            <span class="label">充值代表已阅读并同意</span>
            <span class="douyin protocol-name" @click="show2 = true">《充值协议》</span>
        </div>
        <!-- <div class="complaint" @click="handleComplaint">
          <img src="../assets/images/tusu.png" alt="" width="20" />
          投诉入口
        </div> -->
        <div class="btn-group"></div>
      </div>
      <div class="desktop-row">
        <p>将该网站添加到主屏幕，方便下次充值</p>

        <van-button color="#496ef2" size="normal" @click="oncopy"
          >点我添加</van-button
        >
      </div>
       
      <div class="agreement-row">
        <span>如您充值遇到问题，请联系人工客服</span>
        <van-tag type="danger" size="large" @click="handleDialog2"><van-icon name="service-o" />在线客服</van-tag>
      </div>
      <div class="bottom-tips">
        亲爱的用户，近期平台发现有填写他人账号充值及主播诱导充值的骗局，已有用户被骗。请您提高警惕，切勿轻信此类诱惑，以免遭受财产损失。
      </div>
    </div>
    <div class="add-wx-box" @click="callMe2">加微信有更多优惠<van-icon name="arrow" color="red"/></div>
    <div class="page-footer" v-if="list[currIdx]">
      <van-button
        type="danger"
        style="font-weight: 700"
        color="#fe2c55"
        block
        v-show="btnShow"
        :disabled="btnDisabled"
        @click="weChatPay"
        >
        <img src="../assets/images/wx_icon.png" width="20">
        <img src="../assets/images/ap_icon.png" width="20">
        立即充值 <span>{{ list[currIdx].money }}元</span></van-button
      >
    </div>

    <van-dialog
      class="van-dialog-paytype"
      v-model="payTypeDialog"
      :showConfirmButton="false"
      width="70%"
    >
      <div class="paytype-wrap">
        <div class="pay-header">
          <van-icon name="close" size="20" @click="payTypeDialog = false" />
        </div>
        <div style="padding: 12px 0 0" v-if="list[currIdx]">
          <div class="row row-img"><img :src="userInfo.headImg" alt="" /></div>
          <div class="row">
            <b>{{ userInfo.nickName }}</b>
          </div>
          <div class="row" style="margin-bottom: 30px">
            即将给以上账号充值
            <em style="color: red">{{ list[currIdx].doubi }}</em> 快币
          </div>

          <div class="pay-footer">
            <van-button
              type="primary"
              style="margin-bottom: 15px"
              block
              color="#00c250"
              size="larger"
              icon="wechat-pay"
              @click="dialogPay('wx')"
              >微信支付</van-button
            >
            <van-button  
              v-if="isApPayAuth"
              type="primary" 
              block color="#03A9F4" 
              size="larger" 
              icon="alipay"
              @click="dialogPay('ap')">
              支付宝支付
            </van-button>
          </div>
        </div>
      </div>
    </van-dialog>

    <van-dialog class="van-dialog-paytype" v-model="payTypeDialog2" closeOnClickOverlay :showConfirmButton="false" width="90%" >
        
        <div class="paytype-wrap dialog-tips">
          <div class="risk-header">温馨提示</div>
          <div class="risk-body" v-if="list[currIdx] && isSelfCharger">
              <div class="row row-img" style="gap: 10px">
                <img :src="userInfo.headImg" alt="">
                <b>{{userInfo.nickName}}</b>
              </div>
              <div class="row">充值账号：<b style="position: relative;top: 2px">{{userInfo.userId}}</b></div>
              <div class="row" style="margin-bottom: 20px;"> 请确认此为您本人账号！请不要相信陌生人诱导支付，请勿填写他人账号，谨防受骗导致财产损失！ </div>

              <div class="pay-footer">
                  <van-button  style="margin-bottom: 15px;" block 
                  :disabled="!riskChecked || timerCount > 0"
                  :color="(riskChecked&&!timerCount)?'#ff2e39':''"
                   size="larger"  round
                  @click="payTypeDialog = true; payTypeDialog2 = false">为本人账号充值</van-button>
                 
                  <van-button  block
                   :disabled="!riskChecked || timerCount > 0"
                  :color="(riskChecked&&!timerCount)?'#ff2e39':''" size="larger"  round
                  @click="isSelfCharger = false">他人诱导付款充值</van-button>
                  <p>请认真阅读后确认 <span v-if="timerCount">{{timerCount}}s</span></p>
                  <div class="risk-row">
                    <van-checkbox v-model="riskChecked"  icon-size="16px">继续则视为了解本平台为优惠充值平台，该商品是虚拟产品，因虚拟产品的特殊性，<span>充值成功无法退款，请悉知！</span></van-checkbox>
                  </div>
              </div>
          </div>
          <div class="risk-error" v-else>
            <div class="title"> 他人诱导付款充值一律为诈骗！！！ </div>
            <div class="error-list">
              <p>诈骗案例：</p>
              <p> 1、网络课程-冒充导师-共享屏幕-养号涨粉 </p>
              <p> 2、兼职返利-虚假任务-提现 </p>
              <p> 3、低额充值-高额回报 </p>
              <p> 4、主播送礼-游戏点券道具-充值即赠 </p>
              <p> 5、平台私信-冒充好友 </p>
              <van-button   block 
                  color="#2878ff" size="larger"  round
                  @click="getOut">退出</van-button>
            </div>
            
          </div>
        </div>
      </van-dialog>

    <!-- 支付协议 -->
    <van-popup
      v-model="show2"
      round
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="agreement-floor">
        <div id="Agreement">
          <!---->
          <div class="floor">
            <p class="text">
              1、付款后实时到账，充值成功后无法进行退款操作。<br /><br />
              2、根据文化部规定，购买网游类商品必须年满18周岁。未成年人不得使用本充值服务。<br /><br />
              3、近期不法分子以恶劣的方式进行网络电信诈骗，平台郑重提示你，请勿为他人进行充值，为他人进行充值所产生的损失由用户自行承担。<br /><br />
              4、本平台为第三方优惠渠道，非官方。
            </p>  
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 查看快手号图 -->
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper">
        <img
          src="../assets/images/kuaishou.jpg"
          @click="show = false"
          alt=""
          style="height: 80%"
        />
      </div>
    </van-overlay>
    <van-overlay :show="show3" @click="show3 = false">
      <div class="wrapper" >
        <img
          src="../assets/images/pic2.png"
          alt=""
          style="width: 100%; max-width: 750px"
        />
      </div>
    </van-overlay>
    <!-- 支付选择弹窗 -->
    <!-- <van-dialog v-model="dialog" :show-confirm-button="false">
        <div class="pay-box">
          <van-icon
            name="cross"
            class="close"
            @click="dialog = false"
            color="#999"
            size="18"
          />
          <div class="img-header">
            <img src="../assets/images/user.jpg" alt="" />
          </div>
          <p><b>小王</b></p>
          <div class="pay-group">
            <div style="margin: 30px 0 10px 0; text-align: center">
              即将给以上账户充值 <span style="color: red">60</span> 抖币
            </div>
            <ul class="pay-list">
              <li>
                <van-button
                  type="danger"
                  color="#0dc766"
                  block
                  @click="weChatPay()"
                >
                  <van-icon name="wechat-pay" size="20" />
                  支付测试
                </van-button>
              </li>
              <li>
                <van-button type="danger" color="#2e8ceb" block @click="weChatPay()">
                  <van-icon name="alipay" size="20" />
                  支付宝支付
                </van-button>
              </li>
            </ul>
          </div>
        </div>
      </van-dialog> -->
    <!-- 在线客服弹窗 -->
    <van-overlay :show="dialog2">
      <div class="wrapper">
        <div class="customer-dialog">
          <div class="customer-header">
            <label>联系客服</label>
            <van-icon size="20" name="cross" @click="dialog2 = false"/>
          </div>
          <div class="customer-body">
            <div class="flex-row">
              <van-icon color="#ff9800" size="28px" name="question-o" />
              <span>请选择联系客服的方式</span>
            </div>
          </div>
          <div class="footer-btn">
            <van-tag type="primary" size="large" @click="callUs('phone')">电话客服</van-tag>
            <van-tag plain type="primary" size="large" @click="callUs('online')">在线客服</van-tag>
          </div>
        </div>
        
      </div>
    </van-overlay>
  </div>
</template>
  
  <script>
import { duration } from "moment";
import {
  getAvatarInfoKs,
  reqPayParams,
  getKsAccoutInfo,
  skuList,
  wxAuthCode,
  apPayAuto,
  getIP
} from "../api/api";
import { getUrlCode } from "../utils/wxConfig";
import {Base64} from 'js-base64'
import qs from "qs";
export default {
  components: {},
  data() {
    return {
      show3:false,
      isLogin: false, // 是否获取到快手号
      dialog: false,
      dialog2: false,
      currIdx: 2,
      currItem: {},
      show: false,
      show2: false,
      btnDisabled: true,
      btnShow: true,
      accountNumber: "",
      list: [],
      userInfo: {}, // 用户信息
      payTypeDialog: false,
      needUserCode: true,
      toastLoading: null,
      orderType: '',
      orderInfo: null,
      isApPayAuth: false,
      isLoading: false,
      riskChecked: true,
        timerCount: 3,
        timer: null,
        isSelfCharger: true, // 是否自己充值
        payTypeDialog2: false,
    };
  },
  props: {
    pageInfo: {
      type: Object,
      default: null,
    }
  },
  computed: {
    blackList() {
      return this.$store.state.BLACKLIST;
    },
    // 域名下参数
    webInfoObj() {
      const _webInfo = this.$store.state.websiteInfo;
      return _webInfo[location.host] || _webInfo.defaultData;
    },
  },
  created() {
    const { orderType } = this.webInfoObj;

    this.orderInfo = this.pageInfo || this.webInfoObj


    

    console.log(this.orderInfo)

    this.toastLoading && this.toastLoading.clear();
    // 企业微信环境（发送网页用标题）
    if (this.is_weixn() && this.isWorkWechat()) {
      document.title = "快币充值入口，点击进入！";
    }


    this.getSkuList();
    const ksData = localStorage.getItem("ksData") || "";
    if (ksData) {
      this.userInfo = JSON.parse(ksData);
      this.isLogin = true;
      this.btnDisabled = false;
      this.accountNumber = this.userInfo.userId;
    }
  },
  methods: {
    // 客服链接
    callMe() {
      window.location.href = this.webInfoObj?.onlineChat

    },
    // 添加微信
    callMe2() {
      const {orderType, weChat} = this.webInfoObj
      window.location.href = weChat
    },

    // 客服弹窗
    handleDialog2() {
      this.dialog2 = true
    },
    callUs(type) {
      if(type === 'phone') {
        // 电话
        this.chat()
      }else if(type === 'online') {
        // 在线客服
        this.callMe()
      }
    },


    getSkuList() {
      skuList(this.orderInfo.orderType).then((res) => {
        if (Array.isArray(res)) {
          this.list = res.map((item) => {
            const { amount, productNo, sku } = item;
            return {
              doubi: sku,
              id: productNo,
              money: amount,
            };
          });
        }
      });
    },
    // 是否微信
    is_weixn() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    // 是否企业微信
    isWorkWechat() {
      //获取user-agaent标识头
      var ua = window.navigator.userAgent.toLowerCase();
      //判断ua和微信浏览器的标识头是否匹配
      if (
        ua.match(/micromessenger/i) == "micromessenger" &&
        ua.match(/wxwork/i) == "wxwork"
      ) {
        return true;
      } else {
        return false;
      }
    },
    chat() {
      // this.$router.push('/customerService')

      this.$dialog
        .confirm({
          title: "提示",
          message: "确认拨打电话: 400-606-8160 吗？",
          confirmButtonColor: "#04498d",
        })
        .then(() => {
          // on confirm
          window.location.href = `tel:4006068160`;
        })
        .catch(() => {
          // on cancel
        });
    },
    onBlur() {
      setTimeout(() => {
        this.btnShow = true;
      }, 50);
    },
    onfocus() {
      this.btnShow = false;
    },
    // 切换账号
    loginCheckOut() {
      this.accountNumber = "";
      this.userInfo = "";
      this.isLogin = false;
      this.btnDisabled = true;
    },
    affirmAcNumber() {
      this.getKsNumber();
      // this.getKsNumber2();
    },

    // 快手账号确认（第三方接口）
    getKsNumber2() {
      getAvatarInfoKs(this.accountNumber).then((res) => {
        const { code, data } = res;
        if (code === 0) {
          const { thumb: headImg, name: nickName } = data;
          if (headImg && nickName) {
            this.isLogin = true;
            this.btnDisabled = false;
            this.setStorage({ nickName, headImg });
          } else {
            this.$toast("无法识别快手号");
          }
        } else {
          this.$toast("无法识别快手号");
        }
      });
    },

    // 快手号识别（官方接口，带未成年等提示）
    getKsNumber() {
      this.isLoading = true
      getKsAccoutInfo(this.accountNumber).then((res) => {
        this.isLoading = false
        const {
          result,
          headUrl: headImg,
          userName: nickName,
          userId,
          error_msg,
        } = res;
        if (result === 1) {
          this.isLogin = true;
          this.btnDisabled = false;
          this.setStorage({ nickName, headImg });
        } else {
          this.$toast(error_msg || "无法识别快手号");
        }
      });
    },

    setStorage({ headImg, nickName }) {
      this.userInfo = {
        userId: this.accountNumber,
        headImg: headImg || "",
        nickName: nickName || "",
      };
      localStorage.setItem("ksData", JSON.stringify(this.userInfo));
    },

    handerList(item, idx) {
      console.log(item);

      this.currItem = item;
      this.currIdx = idx;
    },
    openPayMode() {
      this.dialog = true;
    },

    toWxAuth(payType) {
      this.toastLoading = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      const orderType = this.orderInfo.orderType;
      const { money, doubi, id } = this.list[this.currIdx];
      const queryObj = {
        money,
        doubi,
        id,
        orderType,
        type: "ks",
        payType,
        ...this.userInfo,
        sourceUrl: Base64.encode(window.location.href), 
      };

      const params = {
        ...queryObj,
        productNo: id,
      };
      var queryStr = qs.stringify(params);

      if (this.is_weixn()) {

        const u = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2a5f52f9d521f5f3&redirect_uri=${encodeURIComponent('https://mvp.bxsvip.com/#/middleAuth2?'+queryStr)}&response_type=code&scope=snsapi_base#wechat_redirect`;
        window.location.href = orderType == 30 ? u3 : u;
      } 
      else {
        // 直冲
        window.location.href = (`https://mvp.bxsvip.com/#/middleAuth2?${queryStr}`)
      }
    },



    // 微信支付下单
    async weChatPay() {
      const { money, doubi, id } = this.list[this.currIdx];


      var u = navigator.userAgent; 
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
      // 是否可以跳转支付页面
      const {hasPaySys = 'Y'} = this.webInfoObj;
      if(isAndroid && hasPaySys === 'N') {
        this.$router.push('/error')
        return
      }


      // if ((money >= 3000) & (this.orderInfo.orderType == 20)) {
      //   this.$toast("商品库存不足，请选择其他面额。");
      //   return;
      // }

      
      this.getApPayAuto()
    },

    // 获取是否有支付宝支付权限
    getApPayAuto() {
      // 全部放开支付宝
      this.toastLoading = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0
      });

      const {id} = this.list[this.currIdx]
      const { orderType } = this.webInfoObj;
      const params = {
        userId: this.accountNumber,
        productNo: id,
        orderType
      }
      apPayAuto(qs.stringify(params)).then(res => {
        this.toastLoading.clear()
        
        if(res.code === 200) {
          this.isApPayAuth = res.data

          // 如果是支付宝黑名单，增加风险提示弹窗
          if(!this.isApPayAuth) {
            
            this.showRiskDialog()
          } 
          else {  
            // 正常逻辑
            this.payTypeDialog = true; 
          }
        }


      })
    },

    // 显示风险提示弹窗
      showRiskDialog() {
        this.isSelfCharger = true
        this.payTypeDialog2 = true; 
        this.timerCount = 3
        clearInterval(this.timer)
        this.timer = setInterval(() => {
          this.timerCount--
          if(this.timerCount === 0) {
            clearInterval(this.timer)
          }

        }, 1000)
      },
      // 退出
      getOut() {
        this.payTypeDialog2 = false
        this.isSelfCharger = false
      },

    // 弹窗支付选择
    dialogPay(type) {
      if (!this.accountNumber) {
        this.$toast("请输入充值账号");
        return;
      }
      if (this.blackList.includes(this.accountNumber)) {
        this.$toast("暂无权限");
        return;
      }
      this.toWxAuth(type);
    },
    oncopy() {
      this.show3 = true;

      const textarea = document.createElement("textarea");
      // 设置相关属性
      textarea.readOnly = true;
      textarea.style.position = "fixed";
      textarea.style.top = "-99999px";
      // 把目标内容赋值给它的value属性
      textarea.value = "douyin";
      // 插入到页面
      document.body.appendChild(textarea);
      // 调用onselect()方法
      textarea.select();

      // 把目标内容复制进剪贴板, 该API会返回一个Boolean
      document.execCommand("Copy");

      // 移除textarea标签
      document.body.removeChild(textarea);
    },
  },
};
</script>
  
  <style lang="less" scoped>
  .agreement-row{
    padding: 5px 10px;
    color: #333;
    background-color: #f4e0e4;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
.bottom-tips {
  padding: 8px 10px;
  background-color: #eaf4f9;
  margin-top: 10px;
  border-radius: 4px;
  line-height: 22px;
}
.complaint {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  margin: 5px auto;
  font-size: 14px;
  img {
    margin-right: 3px;
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

#Agreement {
  position: relative;
  width: 100vw;
  min-height: 100vh;
  text-align: justify;
  background: #fff;
}
#Agreement .floor {
  padding: 15px 15px 15px;
  color: rgba(0, 0, 0, 0.6);
}
#Agreement .floor strong {
  font-weight: 700;
}
#Agreement .text {
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  line-height: 22px;
  white-space: pre-line;
}

.van-dialog-paytype {
  top: 50% !important;
}
.paytype-wrap {
  padding: 20px 25px;
  position: relative;
  .pay-header {
    text-align: right;
    position: absolute;
    right: 10px;
    top: 10px;
  }
  .row {
    text-align: center;
    margin-bottom: 10px;
  }
  .row-img img {
    border-radius: 4px !important;
    width: 100px;
  }
  .pay-footer {
    .van-button__icon {
      font-size: 20px;
    }
  }
}

.desktop-row {
  margin: 15px 0 15px;
  background: #e0ecff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  img {
    width: 45px;
    border-radius: 6px;
  }
  button {
    height: 28px !important;
    font-size: 12px;
  }
  .addto_list {
    margin: 0 10px;
    flex: 1;
    font-size: 12px;
    .addto_twop {
      color: #8f7f74;
      margin-top: 3px;
      font-size: 10px;
    }
  }
}

.page-footer  {
  .van-button__text {
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 16px;
      font-weight: 500;

  }
}

.add-wx-box {
  position: fixed;
  right: 0;
  bottom: 75px;
  height: 22px;
  line-height: 22px;
  padding: 0 5px 0 10px;
  border-radius: 16px 0 0 16px;
  background-color: #ffda48;
  color: red;
  font-size: 12px;
  font-weight: bold;
}
.protocol-container{
  padding-top: 2px;
    text-align: center;
    color: grey;
    .protocol-name {
      color: #2196F3;
    }
}

.dialog-tips {
  padding: 0;
  font-size: 14px;
  .risk-header {
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #e0f2ff;
    font-size: 16px;
    color: #2878ff;
  }
  .risk-body {
    padding: 20px 20px;
  }
  .risk-error {
    .title {
      font-size: 16px;
      color: #ff2e39;
      padding: 20px 20px 0;
    }
    .error-list {
      padding: 20px 20px;
      p {
        color: #ff2e39;
        margin-bottom: 8px;
        font-size: 14px;
      }
      .van-button {
        border-radius: 999px !important;
        margin: 30px 0 0 0;
      }
    }
  }
  .row,
  .row-img{
    text-align: left;
    display: flex;
    align-items: center;
    img {
      border-radius: 50% 50% !important;
      width: 40px;
    }
  }
  .pay-footer {
    .van-button {
      border-radius: 999px !important;
      font-size: 14px;
      &.van-button--default {
        background-color: #f5f5f5;
        color: #999;
      }
    }
    .van-button--disabled {
      opacity: 1;
    }
    p {
      text-align: center;
      color: #999;
      margin: 12px 0;
      font-size: 14px;
      span {
        color: #2878ff;
      }
    }
    .risk-row {
      font-size: 14px;
      span {
        color: red;
      }
      .van-checkbox {
        align-items: baseline;
      }
    }
  }
  
}
</style>
  